import { ComponentView } from "binder";
import { CheckboxViewModel } from "./checkbox-viewModel"
import { getAsBoolean } from "../utilities";

export class CheckboxView extends ComponentView<CheckboxViewModel>{
    GetViewUniqueId(): string {
        return "V-71796C9F-D43F-47CC-9D2A-23AEC9A060F6"
    }
    loadHtml(): string {
        let element = require('./checkbox.html').default;
        let style = require('./checkbox.less');
        return element;
    }
    constructor() {
       super();
    }
    private checkbox:HTMLInputElement;

    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    public set checked(v: boolean) { 
        this._checked = v; 
        if(this.checkbox)
            this.checkbox.checked=v;
    } public get checked(): boolean { return this._checked;} private _checked: boolean;
    public set indeterminate(v: boolean) { 
        this._indeterminate = getAsBoolean(v); 
        if(this.checkbox)
            this.checkbox.indeterminate = v;
    } public get indeterminate(): boolean { return this._indeterminate;} private _indeterminate: boolean;
    
    changed(){
        this.checked = this.checkbox.checked;
        this.indeterminate = this.checkbox.indeterminate;
    }

    onRenderCompleted(){
        this.checkbox = this.firstlevelElement.querySelector('.V-71796C9F-D43F-47CC-9D2A-23AEC9A060F6.checkbox');
        this.checkbox.checked = this.checked;   
        this.checkbox.indeterminate = this.indeterminate;   
    }
    public set tabindex(v: number) { this._tabindex = v; } public get tabindex(): number { return this._tabindex;} private _tabindex: number;

}
